import ErrorBarChart from './ErrorBarChart'

export default ErrorBarChart
